export default __webpack_public_path__ + "static/media/q-contactUK.5da5db47.png";